import React from 'react';
import Button from 'app/components/Button';
import SelectableBlock from 'app/components/SelectableBlock';

const ResourceTypeSelectionStep = ({
  resourceType,
  setResourceType,
  availableResourceModalType,
  nextStep,
  t,
}) => (
  <div className="add_resource">
    <div className="add_resource__header">
      <p className="title">
        {t('common.modal.program_and_resources_modal.title')}
      </p>
      <p className="sub_title">
        {t('common.modal.program_and_resources_modal.subtitle')}
      </p>
    </div>
    <div className="add_resource__content">
      <SelectableBlock
        selected={resourceType === 'cohort'}
        onChange={() => setResourceType('cohort')}
        subtitle={availableResourceModalType[0].subtitle}
        value={availableResourceModalType[0].value}
        type="checkbox"
        className="select"
      />
      <SelectableBlock
        selected={resourceType === 'resource'}
        onChange={() => setResourceType('resource')}
        subtitle={availableResourceModalType[1].subtitle}
        value={availableResourceModalType[1].value}
        type="checkbox"
        className="select"
      />
    </div>
    <div className="add_resource__footer">
      <Button
        type="btn"
        btnLook="filled"
        onClick={nextStep}
        size="large"
        disabled={!resourceType}
        value={t('common.modal.program_and_resources_modal.continue_btn')}
      />
    </div>
  </div>
);

export default ResourceTypeSelectionStep;
